import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';


import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, TextField} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getObjectByID } from '../../../api/helpers';

class SelectUserDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('this.props.networks')
        //console.log(this.props.networks)
        

        let panelsExpanded = {}
        let defaultNetID = this.props.networkID ? this.props.networkID : ( this.props.networks ? this.props.networks[0].ID : null)
        if(defaultNetID) panelsExpanded[defaultNetID] = true

        this.state = {
            changed: false,
            panelsExpanded: panelsExpanded,
            userFilter: '',
            errors: {
                userName: false
            },
            selected : {
                networkID: null,
                userID: null,
                user: null
            }
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
    }

    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_USER_DIALOG_SELECT', ...this.state.selected })
        }
    }

    handleClose(){
        this.props.onAction({type: 'SELECT_USER_DIALOG_CLOSE'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        console.log('handleFilterInput')
        console.log(event.target.name +' = ' +val)

        this.setState({[event.target.name]: val})
    }

    validate(){
        let error = false

        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    isSelected(netID, userID){
        //console.log('isSelected')
        //console.log(this.state.selected)
        //console.log(netID + ' ' + userID)


        let selected = this.state.selected
        //console.log('selected')
        //console.log(selected)

        let isSelected = netID === selected.networkID && userID === selected.userID

        //console.log('isSelected='+ (isSelected?'true':'false'))

         return isSelected
    }


    getRowStyle(netID, groupID, slot){
        let style = {
            background: this.isSelected(netID, groupID, slot) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    select(netID, userID){
        let network = getObjectByID(netID, this.props.networks)
        let user = getObjectByID(userID, network.users)

        //console.log('select')
        //console.log(netID)
        //console.log(userID)

        let selected = {
            networkID: netID,
            userID: user.ID,
            user: user.Name
        }
        //console.log('selected')
        //console.log(selected)

        this.setState({selected: selected})
    }

    selectClose(netID, userID){
        let network = getObjectByID(netID, this.props.networks)
        let user = getObjectByID(userID, network.users)

        let selected = {
            networkID: netID,
            userID: user.ID,
            user: user.Name
        }

        if(this.validate()){
            this.props.onAction({type: 'SELECT_USER_DIALOG_SELECT', ...selected })
        }
    }

    getUsers(users){

        users.sort((item1, item2) => (item1.Name > item2.Name))
        return users

    }


    render(){
        const {t} = this.props


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        //const margin = {margin:'16px 0 8px 0'}

        //console.log('render SelectExternalNetworkGroupDialog')
        //console.log(this.props)

        let networks = []
        if(this.props.networkID){
            //console.log('single network ')
            //console.log(this.props.networks)
            networks = this.props.networks.filter(net => net.ID==this.props.networkID)
            console.log(networks)
        }else{
            networks = this.props.networks
        }


        let filter = this.state.userFilter.toLowerCase()
        
        if(filter){
            console.log('networks before filter')
            console.log(networks)
            networks = networks.map(
                net => ({
                            ID: net.ID, 
                            Name: net.Name,
                            users: net.users.filter(
                                item => item.Name.toLowerCase().indexOf(filter) >= 0 
                            )
                        })
            )
            //console.log('networks filter')
            //console.log(networks)
        }

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>        

            <Box textAlign="center">
                <TextField
                    name="userFilter"
                    id="userFilter"
                    onChange={this.handleFilterInput}
                    label={t("Filter")}
                    value={this.state.userFilter}
                    style={{width:'100%'}}
                    error={false}
                    autoComplete="new-password"
                />
            </Box>

            {networks.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?false:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                    <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                            </TableRow>
                        </TableHead>
                    
                    <TableBody>
                    {this.getUsers(net.users).map(user=>
                    <TableRow key={user.ID}  
                        onClick={event=>this.select(net.ID, user.ID)}
                        onDoubleClick={event=>this.selectClose(net.ID, user.ID)}
                        style={this.getRowStyle(net.ID, user.ID)}>
                        <TableCell>
                            {user.Name}
                        </TableCell>
                    </TableRow>
                    )}
                    </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect} variant="contained" color="primary">
            {t('Select')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const SelectUserDialog = withTranslation()(SelectUserDialog_);